/* unplugin-vue-components disabled */import script from "./FlodableContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlodableContainer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__